'use client';

import Link from 'next/link';
import Image from 'next/image';

import { IResolvedBreadcrumbItem } from '@/src/utils/breadcrumb.mapper';

type IBreadcrumbProps = {
  resolvedBreadcrumb: IResolvedBreadcrumbItem[] | null;
  locale: string;
};

export const Breadcrumb = ({
  resolvedBreadcrumb,
  locale,
}: IBreadcrumbProps) => {
  return (
    <>
      {resolvedBreadcrumb && (
        <div className={'relative mx-auto flex w-full max-w-1200 px-4 py-5'}>
          {resolvedBreadcrumb.map((item, index) => (
            <div
              key={`breadcrumb-${item.text}`}
              className={'flex items-center gap-1 '}
            >
              {item.link ? (
                <Link
                  href={`/${locale}${item.link}`}
                  className={'font-bold text-gray underline'}
                  onClick={() => {
                    window.dataLayer?.push({
                      event: 'click_button',
                      click_id: `/${locale}${item.link}`,
                      click_label: item.text,
                    });
                  }}
                >
                  {item.text}
                </Link>
              ) : (
                <span className={'text-gray'}>{item.text}</span>
              )}
              {index < resolvedBreadcrumb.length - 1 && (
                <Image
                  src={'/static/icons/chevron-right.svg'}
                  alt={'Chevron breadcrumb'}
                  width={16}
                  height={16}
                  className={'mr-2 flex size-4 items-center justify-center p-1'}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
